// /**
//  * parcel - Add
//  */

// React
import React, { useContext } from 'react';

// UI
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { TextField, Grid, Button } from '@material-ui/core';

// Icon
import Icon from '@mdi/react';
import { mdiCounter, mdiArchiveOutline, mdiBarcodeScan } from '@mdi/js';

import AuthContext from '../../authContext';
import { InventoryItem, Item } from './interfaces';
import Modal from '../../components/Modal';
import { useForm } from 'react-hook-form';
import { translate } from '../../utils/helpers';

type Props = {
  orderItem: Item;
  inventoryItems: any;
  serialNumber: boolean;
  onClose: () => void;
  updateInventoryItems: (item: InventoryItem) => void;
  getInventoryItemsWithSerial: (serial: string) => void;
  pickOrderItem: () => void;
  openBarcodeScan: boolean;
  openBarcode: (open: boolean) => void;
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    detail: {
      borderBottom: '1px solid #d8d8d8',
      paddingBottom: '10px',
      marginBottom: '20px',
      width: '100%',
      '& .icon, & h4.property': {
        color: '#8a8a8a',
      },
      '& .MuiDivider-root': {
        margin: '24px 0',
        color: '#d8d8d8',
      },
      '& h4': {
        margin: 0,
        padding: '0 8px',
      },
    },
    margin: {
      // margin: theme.spacing(1),
    },
    withoutLabel: {
      marginTop: theme.spacing(3),
    },
    textField: {
      // width: '25ch',
    },
    textInput: {
      // width: '25ch',
      '& input, .MuiSelect-root': {
        padding: '6px 0 12px !important',
      },

      '& .MuiInput-underline::before': {
        borderBottom: '1px solid #d8d8d8 !important',
      },
    },
    item: {
      display: 'flex',
      alignSelf: 'center',
      alignItems: 'center',
      fontWeight: 500,
      width: '100%',
      '& > *': {
        // margin: theme.spacing(0, 0, 0, 1),
      },
    },
    icon: {
      // marginRight: theme.spacing(1),
    },
    label: {
      display: 'flex',
      alignItems: 'center',
      fontSize: '14px',
      fontWeight: 400,
      color: '#8A8A8A',
      marginRight: '8px',
      marginTop: '21px',
    },
    addIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      // marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.green.main,
      },
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  })
);

export default function Add(props: Props) {
  const classes = useStyles();
  const { handleSubmit } = useForm();
  const [serial, setSerial] = React.useState<string>('');
  const [openBarcodeScanner, setOpenBarcodeScanner] = React.useState<boolean>(
    props.openBarcodeScan
  );

  const getInventoryItem = () => {
    props.getInventoryItemsWithSerial(serial);
  };

  const handleCloseModal = () => {
    setOpenBarcodeScanner(false);
    props.openBarcode(false);
  };

  let variantName =
    props.orderItem.type === 'PRODUCT'
      ? props.orderItem.productName
      : translate(props.orderItem.type, 'inventory');
  for (let i = 0; i <= 2 && props.orderItem.featureAndValues[i]; i++) {
    variantName = variantName.concat(
      ' - ',
      props.orderItem.featureAndValues[i].key,
      ' : ',
      props.orderItem.featureAndValues[i].value
    );
  }

  if (props.orderItem.sellerName || props.orderItem.providerName) {
    const sellerName =
      props.orderItem.sellerName ?? props.orderItem.providerName;
    variantName = variantName.concat(' ( ', sellerName, ' )');
  }

  return (
    <>
      <div>
        <Grid
          className={classes.detail}
          container
          spacing={5}
          alignItems="center"
        >
          <Grid item container alignItems="center" sm={6}>
            <Icon className="icon" path={mdiArchiveOutline} size={1} />
            <h4 className="property">نام کالا :</h4>
            <h4>{variantName}</h4>
          </Grid>
          <Grid item container alignItems="center" sm={6}>
            <Icon className="icon" path={mdiCounter} size={1} />
            <h4 className="property">تعداد کالا :</h4>
            <h4>{props.orderItem.amount}</h4>
          </Grid>
          <Grid item container alignItems="center" sm={6}>
            <Icon className="icon" path={mdiCounter} size={1} />
            <h4 className="property">آدرس یونیت:</h4>
            <h4>
              {props.units.map((unit, index) => {
                return <span>{unit.code}/</span>;
              })}
            </h4>
          </Grid>
        </Grid>
        {/* <Grid>
          <List
            modal={true}
            onItemSelected={item => setItem(item)}
            data={props.inventoryItems}
            pickItem={serial => getInventoryItemBySerial(serial)}
            serialNumber={props.serialNumber}
            setOpenBarcode={getOpenBarcodeScanner}
          />
        </Grid> */}
        <Grid container spacing={2} style={{ marginTop: '30px' }}>
          {/* <Grid item container xs={8}>
            <Button
              fullWidth
              type="button"
              size="large"
              data-cy="search"
              autoFocus
              variant="contained"
              color="secondary"
              onClick={() => props.pickOrderItem()}
              disabled={!serialBarcode}
            >
              {'تایید'}
            </Button>
          </Grid> */}
          <Grid item container xs={12}>
            <Button
              fullWidth
              variant="contained"
              onClick={props.onClose}
              size="large"
              data-cy="search"
            >
              {'بستن'}
            </Button>
          </Grid>
        </Grid>
        <Modal
          onClose={handleCloseModal}
          maxWidth="lg"
          open={openBarcodeScanner}
          title={
            <div className={classes.addIcon}>
              <Icon path={mdiBarcodeScan} size={4} color="#5c5c5c" />
            </div>
          }
          content={
            <div style={{ width: '300px' }}>
              <form onSubmit={handleSubmit(getInventoryItem)}>
                <Grid
                  style={{ margin: 0 }}
                  className={classes.detail}
                  container
                  spacing={5}
                  alignItems="center"
                >
                  {'شماره سریال کالای مورد نظر را وارد کنید'}
                </Grid>

                <Grid>
                  <TextField
                    fullWidth
                    id="serialNumber"
                    name="name"
                    autoFocus
                    value={serial}
                    onChange={e => setSerial(e.target.value)}
                    label="شماره سریال"
                  />
                </Grid>
                <Grid container spacing={2} style={{ marginTop: '30px' }}>
                  <Grid item container xs={8}>
                    <Button
                      fullWidth
                      type="submit"
                      size="large"
                      data-cy="search"
                      autoFocus
                      variant="contained"
                      color="secondary"
                      disabled={!serial}
                    >
                      {'تایید برداشتن کالا'}
                    </Button>
                  </Grid>
                  <Grid item container xs={4}>
                    <Button
                      fullWidth
                      type="button"
                      variant="contained"
                      onClick={handleCloseModal}
                      size="large"
                      data-cy="search"
                    >
                      {'انصراف'}
                    </Button>
                  </Grid>
                </Grid>
              </form>
            </div>
          }
        />
      </div>
    </>
  );
}
